<template>

  <SrcBackgroundScroll @scrolled="isShrunk = $event">
      <HeadlineSubScroll
        :title="$t('settings.settingsfor', { wallbox: decodeHtmlEntities($store.state.WbName) })"
        target="/Main"
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
      >
        <template #icon>
          <IconSettings
            class="transition-all duration-300"
            :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"
          />
        </template>
        <template #subline>
          {{ $t('settings.overview') }}
        </template>
      </HeadlineSubScroll>

    <!-- Content below header -->
    <div class="my-24 sm:my-28 px-3 sm:px-4 max-w-5xl">
        <div
          v-for="nav in navlist"
          :key="nav.index"
          class="w-full bg-skin-b-list-back border border-skin-b-list-bord shadow mt-4 rounded-lg"
        >
          <SettingsItem
            :icon="nav.icon"
            :title="nav.title"
            :subtitle="nav.subtitle"
            :subtitleshort="nav.subtitleshort"
            :target="nav.target"
            :showPing="nav.showPing"
          />
        </div>
      </div>
  </SrcBackgroundScroll>
</template>


<script>
import { useI18n } from 'vue-i18n';
import SettingsItem from './elements/SettingsItem.vue';
import IconSettings from './icons/IconSettings.vue';
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue';
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue';

export default {
  name: 'SettingPage',
  components: {
    SettingsItem,
    IconSettings,
    SrcBackgroundScroll,
    HeadlineSubScroll,
  },
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n }
  },
  data() {
    return {
      isLoading: false,
      navlist: [],
      client_settings: [],
      isShrunk: false,
    };
  },
  methods: {
    decodeHtmlEntities(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    getRoleBasedNav(commonNav, navOcpp, navBalance, navMesh) {
      const role = this.$store.state.Role;

      const operatorNav = [
        ...commonNav.slice(0, 2),
        { index: 3, title: this.$t('settings.public'), icon: 'publicshare', target: '/SetPublic' },
        { index: 4, title: this.$t('settings.easycheck'), icon: 'easycheckin', target: '/SetEasycheck' },
        ...navBalance,
        ...navMesh,
        ...navOcpp,
        { index: 8, title: this.$t('settings.service'), icon: 'mail', target: '/SetService' },
        ...commonNav.slice(2),
      ];

      const adminNav = [
        ...commonNav.slice(0, 1),
        { index: 14, title: this.$t('settings.country'), icon: 'editsquare', target: '/SetCountry' },
        ...commonNav.slice(1, 2),
        ...navBalance,
        ...navMesh,
        ...navOcpp,
        ...commonNav.slice(2),
        { index: 13, title: this.$t('settings.paragraph14'), icon: 'para14', target: '/SetPara14' },
      ];

      const userNav = [
        ...navOcpp,
        {
          index: 8,
          title: this.$t('settings.update'),
          icon: 'update',
          target: '/SetUpdate',
        },
      ];

      return role === 'operator' ? operatorNav : role === 'admin' ? adminNav : userNav;
    },
    async loadSettings() {
      this.isLoading = true;

      try {
        const response = await this.axios.get(
          `wallbox/info.php?action=get_settings&user=${this.$store.state.token}&client=${this.$store.state.WbId}`
        );

        const data = response.data;

        if (data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        }

        if (data.status !== 'ok') {
          console.error('Error loading client_settings');
          return;
        }

        this.client_settings = data.tbl_settings;
        this.$store.commit('setPubAccess', this.client_settings.publicAccess == 1);

        const isLTE = this.client_settings.lte == 1;
        this.$store.commit('setLTE', isLTE);
        const netTitle = isLTE ? this.$t('settings.networklte') : this.$t('settings.network');

        const commonNav = [
          { index: 1, title: this.$t('settings.general'), icon: 'editsquare', target: '/SetGeneral' },
          { index: 2, title: this.$t('settings.solar'), icon: 'solarpower', target: '/SetSolar' },
          { index: 7, title: this.$t('settings.modbus'), icon: 'modbus', target: '/SetModbus' },
          
          {
            index: 9,
            title: this.$t('settings.update'),
            subtitle: this.$store.state.NewSW ? this.$t('menu.subsettings') : '',
            subtitleshort: this.$store.state.NewSW ? this.$t('menu.subsettingsshort') : '',
            icon: 'update',
            target: '/SetUpdate',
            showPing: this.$store.state.NewSW,
          },
          //{ index: 10, title: this.$t('settings.backup'), icon: 'backup', target: '/SetBackup' },
          { index: 11, title: netTitle, icon: 'network', target: '/SetNetwork' },
        ];

        const navOcpp =
          this.client_settings.ocpp == 1
            ? [{ index: 5, title: this.$t('settings.ocpp'), icon: 'ocpp', target: '/SetOcpp' },
               { index: 6, title: this.$t('settings.ocppdlm'), icon: 'ocpp', target: '/SetOcppDlm' }]
            : [];
        
        const navBalance =
          this.$store.state.WbId == this.$store.state.WbLogId
            //? [{ index: 12, title: this.$t('settings.easybalance'), icon: 'powermanagement', target: `https://${this.$store.state.WbLogIp}:6443/` }]
            ? [{ index: 12, title: this.$t('seteasybalance.loadmanagement'), icon: 'powermanagement', target: '/SetEasybalance' }]
            : [];

        const navMesh = [{ index: 13, title: this.$t('setmesh.rfidsecurity'), icon: 'security', target: '/SetMesh' }];

        //const navMesh =
        //  this.$store.state.Mesh
        //    ? [{ index: 13, title: this.$t('setmesh.rfidsecurity'), icon: 'ocpp', target: '/SetMesh' }]
        //    : [];

        this.navlist = this.getRoleBasedNav(commonNav, navOcpp, navBalance, navMesh);

      } catch (error) {
        console.error('Error loading settings:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created(){
    this.loadSettings();
  }
};
</script>

<style scoped>
</style>
